var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.875C9.99747 1.875 8.0399 2.46882 6.37486 3.58137C4.70981 4.69392 3.41206 6.27523 2.64572 8.12533C1.87939 9.97543 1.67888 12.0112 2.06955 13.9753C2.46023 15.9393 3.42454 17.7435 4.84055 19.1595C6.25656 20.5755 8.06066 21.5398 10.0247 21.9305C11.9888 22.3211 14.0246 22.1206 15.8747 21.3543C17.7248 20.5879 19.3061 19.2902 20.4186 17.6251C21.5312 15.9601 22.125 14.0025 22.125 12C22.122 9.3156 21.0543 6.74199 19.1562 4.84383C17.258 2.94567 14.6844 1.87798 12 1.875ZM19.875 12C19.8766 13.7 19.3255 15.3544 18.3047 16.7137L7.28625 5.69531C8.45659 4.82082 9.84713 4.28913 11.3024 4.1597C12.7576 4.03027 14.2201 4.30821 15.5264 4.96243C16.8327 5.61665 17.9313 6.62136 18.6993 7.86421C19.4672 9.10705 19.8743 10.539 19.875 12ZM4.125 12C4.12338 10.3 4.67452 8.64562 5.69532 7.28625L16.7138 18.3047C15.5434 19.1792 14.1529 19.7109 12.6977 19.8403C11.2424 19.9697 9.77989 19.6918 8.47358 19.0376C7.16728 18.3834 6.06872 17.3786 5.30075 16.1358C4.53279 14.8929 4.1257 13.461 4.125 12Z",
    fill: "#8E8E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabled);
export default __webpack_public_path__ + "static/media/disabled.26eb43ab7351c2eaa84ddb330d3a037e.svg";
export { ForwardRef as ReactComponent };